import { useContext, useEffect, useState } from 'react';
import { TabContext } from '../../../Context/TabContext';
import { urls } from './api/urls';
import useHttp from '../../../hooks/use-http';
import CartItem from './components/CartItem';
import { formatPrice } from '../../../../utils/FormatPrice';
import MyButton from '../../UI/myButton/MyButton';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import Inputs from './components/inputs';
import { formatDateBody } from '../../../../utils/FormatDate';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import toast from 'react-hot-toast';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'; // Uvoz ikone
import { useTranslation } from 'react-i18next';

const INITIAL_VALUES = {
  id: 0,
  ceoBrDok: '',
  datum: formatDateBody(new Date()),
  idMasine: null,
  nazivMasine: '',
  idVeze: null,
  ukupanIznos: 0.0,
  napomena: '',
  files: [],
  base64: '',
  brZahteva: '',
};

const PorudzbenicaPregled = () => {
  const { t, i18n } = useTranslation();
  const { tabsData, activeComponent } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localIdDok = dataLocal?.data ? dataLocal?.data : {};
  const [stavke, setStavke] = useState([]);
  const { getData, isLoading } = useHttp('');
  const [openDialog, setOpenDialog] = useState(false);
  const [formValue, setFormValue] = useState(INITIAL_VALUES);
  const [ponudeList, setPonudeList] = useState([]);
  const [naziv, setNaziv] = useState('');

  const vratiStavke = async () => {
    const config = {
      url: urls.VRATI_STAVKE,
      method: 'POST',
      data: {
        id: localIdDok.idDok,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const response = await getData(config);
    if (response) {
      setStavke(response);
    }
  };

  const vratiDokumenta = async () => {
    const config = {
      url: urls.VRATI_DOKUMENTA,
      method: 'POST',
      data: {
        id: localIdDok.idDok,
      },
    };
    const response = await getData(config);
    if (response) {
      setPonudeList(response);
    }
  };

  useEffect(() => {
    setFormValue(localIdDok);
    vratiStavke();
    vratiDokumenta();
  }, []);

  const handleOpenPopPonude = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSave = async () => {
    const fd = new FormData();
    fd.append('id', 0);
    fd.append('datum', formValue.datum);
    fd.append('idVeze', formValue.idDok);
    fd.append('ukupanIznos', +formValue.ukupanIznos);
    fd.append('napomena', formValue.napomena);
    fd.append('idMasine', 0);
    fd.append('idKorProm', +localStorage.getItem('idKorisnika'));

    for (let i = 0; i < formValue.files.length; i += 1) {
      fd.append('Slika', formValue.files[0]);
    }
    const config = {
      method: 'POST',
      url: urls.INSERT_PONUDE,
      data: fd,
    };
    const response = await getData(config);
    if (response.id > 0) {
      const message = 'Uspešan unos ponude';
      toast.success(message);
      vratiDokumenta();
      setOpenDialog(false);
      return;
    }
    toast.error(handleErrorMessage(response));
  };

  const handleDownload = (url) => {
    window.open(url, '_blank');
  };
  const downloadFile = async (fileUrl, fileName) => {
    const config = {
      method: 'POST',
      url: 'Dokumenta/konvertovanje_base64',
      data: { vrednost: fileUrl },
    };

    const response = await getData(config);

    const base64Data = response; // Pretpostavljam da response.data sadrži base64 string.

    // Konvertovanje base64 stringa u Blob objekt
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    // Kreiranje URL-a za Blob objekt
    const blobUrl = URL.createObjectURL(blob);

    // Kreiranje i klikanje na link element za preuzimanje datoteke
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName); // Postavite naziv datoteke
    document.body.appendChild(link);
    link.click();

    // Čišćenje URL-a i uklanjanje linka
    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(link);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '50px' }}>
      <div style={{ width: '600px' }}>
        {stavke.map((item) => (
          <CartItem key={item.id} item={item} />
        ))}
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'end',
              flexDirection: 'column',
            }}
          >
            <div>{t('total')}</div>
            <div style={{ fontWeight: 'bold' }}>
              {stavke.length > 0 ? formatPrice(stavke[0].suma) : 0}{' '}
              <span style={{ color: 'gray', fontSize: '15px' }}>EUR</span>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
        }}
      >
        {localStorage.idFirme === '1' && (
          <MyButton
            style={{
              backgroundColor: 'orange',
              color: 'white',
            }}
            label={t('createOffer')}
            onClick={handleOpenPopPonude}
          />
        )}

        <div>
          {/* Provera dužine ponudeList */}
          {ponudeList.length > 0 ? (
            <>
              <div>{t('offers')}</div>
              {ponudeList.map((ponuda) => (
                <div
                  key={ponuda.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '10px',
                    background: '#ffe8bd',
                    borderRadius: '5px',
                    padding: '0 5px',
                  }}
                >
                  <InsertDriveFileIcon
                    style={{ marginRight: '10px', fontSize: '30px' }}
                  />

                  <span
                    onClick={() => downloadFile(ponuda.ponudaUrl, ponuda.name)}
                    style={{
                      cursor: 'pointer',
                      textDecoration: 'underline',
                    }}
                  >
                    {ponuda.name}
                  </span>
                </div>
              ))}
            </>
          ) : (
            <div>{t('messages.noOfferMessage')}</div>
          )}
        </div>
      </div>
      <MuiDialog
        maxWidth="sm"
        open={openDialog}
        title={formValue.id === 0 ? 'Unos ponude' : 'Izmena ponude'}
        content={
          <Inputs
            formValue={formValue}
            setFormValue={setFormValue}
            naziv={naziv}
            setNaziv={setNaziv}
          />
        }
        handleClose={handleCloseDialog}
        handleConfirm={handleSave}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default PorudzbenicaPregled;
